import { render, staticRenderFns } from "./StickersHistoryDatatableComponent.vue?vue&type=template&id=0c6e0364&"
import script from "./StickersHistoryDatatableComponent.vue?vue&type=script&lang=js&"
export * from "./StickersHistoryDatatableComponent.vue?vue&type=script&lang=js&"
import style0 from "./StickersHistoryDatatableComponent.vue?vue&type=style&index=0&id=0c6e0364&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports